export default "__VITE_ASSET__IgMGxoRs__"